<!-- Floating launcher button -->
<button
  type="button"
  class="assistant-fab d-print-none"
  [class.assistant-fab--active]="isOpen()"
  (click)="togglePanel()"
  aria-label="Open assistant"
>
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3Zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11h-2Z"
    />
  </svg>
</button>

@if (isOpen()) {
  <div class="assistant-panel d-print-none">
    <div class="assistant-panel__header">
      <span class="assistant-panel__title">Assistant</span>
      <button type="button" class="assistant-panel__close" (click)="close()" aria-label="Close assistant">&times;</button>
    </div>

    @if (state().error) {
      <div class="assistant-alert">
        {{ state().error }}
        <button type="button" class="assistant-alert__close" (click)="agent.clearError()" aria-label="Dismiss">&times;</button>
      </div>
    }

    <div #history class="assistant-panel__history">
      @if (state().conversationHistory.length === 0 && !state().userTranscript && !state().agentTranscript) {
        <div class="assistant-empty">
          Tap the microphone and start talking to the assistant.
        </div>
      }

      @for (turn of state().conversationHistory; track $index) {
        <div class="assistant-bubble" [class.assistant-bubble--user]="turn.role === 'user'">
          {{ turn.transcript }}
        </div>
      }

      <!-- Live (in-progress) transcripts -->
      @if (state().userTranscript) {
        <div class="assistant-bubble assistant-bubble--user assistant-bubble--partial">
          {{ state().userTranscript }}
        </div>
      }
      @if (state().agentTranscript) {
        <div class="assistant-bubble assistant-bubble--partial">
          {{ state().agentTranscript }}
        </div>
      }
    </div>

    <div class="assistant-panel__footer">
      <div class="assistant-status">
        @if (state().isRecording) {
          <span class="assistant-status__dot assistant-status__dot--rec"></span> Listening…
        } @else if (state().isSpeaking) {
          <span class="assistant-status__dot assistant-status__dot--speak"></span> Speaking…
        } @else if (state().isConnected) {
          <span class="assistant-status__dot"></span> Connected
        } @else {
          <span class="assistant-status__dot assistant-status__dot--off"></span> Not connected
        }
      </div>

      <button
        type="button"
        class="btn"
        [class.btn-primary]="!state().isConnected && !state().isRecording"
        [class.btn-danger]="state().isConnected || state().isRecording"
        (click)="toggleSession()"
      >
        @if (state().isConnected || state().isRecording) {
          Stop
        } @else {
          Start talking
        }
      </button>
    </div>
  </div>
}
